<template>
    <div class="customer-area-menu-component container py-12 md:py-16 lg:pb-20">
        <h2 class="text-center mb-10">{{ trans.get('customer.my-account') }}</h2>
        <ul class="flex flex-col space-y-5 mb-16 mx-auto">
            <li>
                <a class="cursor-pointer inline-flex items-center" @click="go('customer.my-orders')">
                    <img loading="lazy" class="mr-4" src="/img/icons/orders.svg">
                    {{ trans.get('customer.my-orders') }}
                </a>
            </li>
            <li class="flex items-center">
                <a class="cursor-pointer inline-flex items-center" @click="go('customer.personal-data')">
                    <img loading="lazy" class="mr-4" src="/img/icons/personal-data.svg">
                    {{ trans.get('customer.personal-data') }}
                </a>
            </li>
            <li class="flex items-center pt-2">
                <a class="cursor-pointer inline-flex items-center" @click="go('customer.address-book')">
                    <img loading="lazy" class="mr-4" src="/img/icons/addresses.svg">
                    {{ trans.get('customer.address-book') }}
                </a>
            </li>
        </ul>
        <div class="flex justify-center mb-20">
            <a href="TODO" class="text-center underline">{{ trans.get('customer.shipping-returns-policy')  }}</a>
        </div>
        <button class="btn btn-primary mb-20 mx-auto flex items-center" @click="logout">
            <span class="material-icons mr-3">logout</span>
            <span>{{ trans.get('customer.logout') }}</span>
        </button>
    </div>
</template>

<script>
import { goToRouteWithName } from '../../mixin';

export default {
    mixins: [goToRouteWithName],

    methods: {
        go(name) {
            this.$store.commit('customerSetMobileMenuShown', false);
            this.$router.push({ name: name });
        },
        logout() {
            document.querySelector('#logout-form').submit();
        }
    },
}
</script>

<style lang="scss" scoped>
.customer-area-menu-component {
    background: #f4f3ed;

    img {
        width: 2rem;
    }
    ul {
        max-width: 20rem;
    }
}
</style>
